import { createFileRoute } from "@tanstack/react-router";

import IntakeDetail from "@/pages/intake/IntakeDetail";

function IntakeDetailPage() {
  const { caseId } = Route.useParams();
  return <IntakeDetail caseId={caseId} />;
}

export const Route = createFileRoute("/intake/$caseId")({
  component: IntakeDetailPage,
});
